import { requestGet, requestGetFilterEmpty } from '@/common/request';

export default {
  // 主题活动维度效果数据查询
  async proSalesDataActInfo(query, config) {
    return await requestGet('/proSalesData/actInfo', query, config);
  },
  // 商品-主题活动维度效果数据查询
  async proSalesDataGoodInfo(query, config) {
    return await requestGet('/proSalesData/goodInfo', query, config);
  },
  // 商品-活动效果数据下载
  async proSalesDataDownloadActInfo(query, config) {
    return await requestGet('/proSalesData/downloadActInfo', query, config);
  },
};
